if ($('.js-media-block-video-control').length) {
    $('.js-media-block-video-control').on('click', function () {
        let videoSrc = $(this).data('videoSrc');
        let videoPoster = $(this).data('videoPoster');
        $('.js-media-block-video-control').removeClass('is-selected');
        $(this).addClass('is-selected');
        $(this).closest('.c-media-block__video-controls').prev('.c-media-block__video').attr({src:videoSrc, poster:videoPoster}).focus();
    });
}